import type { DataTableColumn, DataTableRenderCellParams } from '@/components/custom/erp';
import type { DiaChiNhanHang, KhoHang } from '@/types/schemas';

type SearchDataTableColumn = DataTableColumn<KhoHang> & {
  checkboxSelection?: boolean;
};

export const getDataTableColumns = (): DataTableColumn<DiaChiNhanHang>[] => [
  { field: 'ma_dcnh', headerName: 'Mã địa chỉ', width: 120 },
  { field: 'ten_dcnh', headerName: 'Tên địa chỉ', width: 200 },
  {
    field: 'ma_kho',
    headerName: 'Mã kho',
    width: 100,
    renderCell: (params: DataTableRenderCellParams<DiaChiNhanHang>) => params.row.ma_kho_data?.ma_kho || ''
  }
];

export const khoSearchColumns: SearchDataTableColumn[] = [
  { field: 'ma_kho', headerName: 'Mã kho', width: 120 },
  { field: 'ten_kho', headerName: 'Tên kho', width: 250 },
  {
    field: 'don_vi',
    headerName: 'Đơn vị',
    width: 120,
    renderCell: (params: DataTableRenderCellParams<KhoHang>) => params.row.unit_data?.ten_unit || ''
  },
  { field: 'theo_doi_vi_tri', headerName: 'Theo dõi vị trí', width: 120, checkboxSelection: true }
];
